import React from "react";
import { Accordion, Button } from "react-bootstrap";
import Spinner from "reactstrap/lib/Spinner";
import { base_url, merchant_url } from "assets/utils/const";
import CryptoJS from "crypto-js";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import { emailValidation, generateCaptcha } from "assets/utils/constFuntion";
import ReCaptcha from "./ReCaptcha";
import { withRouter } from "react-router";
// import { useLocation } from "react-router-dom";

class Signin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isLoaded: false,
      isInvalid: false,
      email: "",
      isValidEmail: true,
      captcha: "",
      isInvalidCaptcha: false,
      userNotValid: false,
      number: false,
      specialChar: false,
      minLength: false,
      upperCase: false,
      lowerCase: false,
      passwordError: "",
      errorMessage: "",
      genCaptcha: "",
    };
  }
  componentDidMount() {
    // loadCaptchaEnginge(6, "black", "white");
    this.generateNewCaptcha();
  }

  generateNewCaptcha = () => {
    const genCaptcha = generateCaptcha();
    this.setState({ genCaptcha });
  };
  showcontactuspage = (props) => {
    // console.log("button click.....");
    // this.setState({
    //   open: !this.state.open,
    // });
    window.location.href = "/contactus";
  };

  closepage = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  // myCall = () => {
  //   let location = this.props.location;
  //   let params = new URLSearchParams(location.search).get("name");
  //   alert(params);
  //   // const params = queryString.parse(window.location.search);
  //   // console.log(params);
  //   // alert("prrr");
  // };

  // handleSubmit = (event) => {
  //   event.preventDefault();
  //   const { minLength, upperCase, lowerCase, number } = this.state;
  //   if (!this.handleEmail()) {
  //     return false;
  //   }
  //   // if (!minLength || !upperCase || !lowerCase || !lowerCase || !number) {
  //   //   this.setState({ passwordError: "Invalid password format" });
  //   //   return false;
  //   // } else {
  //   //   this.setState({ passwordError: "" });
  //   // }
  //   if (this.state.captcha === this.state.genCaptcha) {
  //     this.setState({ isInvalidCaptcha: false });
  //   } else {
  //     this.setState({ isInvalidCaptcha: true });
  //     return false;
  //   }

  //   var uname = event.target.txtUsername.value;
  //   var upass = event.target.txtPassword.value;
  //   this.setState({
  //     isLoaded: true,
  //     isInvalid: false,
  //     userNotValid: false,
  //     errorMessage: "",
  //   });

  //   var key = "oqUl4D0LqA4plZw4reAX/K3UKJoQdet0k/N6X6K4Y5k=";
  //   var base64IV = "0123456789abcdef";

  //   var parsedBase64Key = CryptoJS.enc.Base64.parse(key);
  //   var IV = CryptoJS.enc.Utf8.parse(base64IV);
  //   // Encryption process
  //   if (typeof upass !== "string") {
  //     upass = upass.toString();
  //   }

  //   // this is Base64-encoded encrypted data
  //   var encryptedData = CryptoJS.AES.encrypt(upass, parsedBase64Key, {
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7,
  //     iv: IV,
  //   });
  //   // console.log("encryptedData = ", encryptedData.toString());
  //   const encryptedCipherText = encryptedData.toString();

  //   // var decryptedData = CryptoJS.AES.decrypt(
  //   //   encryptedCipherText,
  //   //   parsedBase64Key,
  //   //   {
  //   //     mode: CryptoJS.mode.CBC,
  //   //     padding: CryptoJS.pad.Pkcs7,
  //   //     iv: IV,
  //   //   }
  //   // );
  //   // console.log( "DecryptedData = " + decryptedData );
  //   // this is the decrypted data as a string
  //   // var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
  //   // console.log("DecryptedText = " + decryptedText);

  //   fetch(`${base_url}api/merchantLogin`, {
  //     method: "POST",
  //     headers: {
  //       "Access-Control-Allow-Origin": "*",
  //       "Access-Control-Allow-Methods":
  //         "GET, POST, PATCH, PUT, DELETE, OPTIONS",
  //       "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       user_id: uname,
  //       password: encryptedCipherText,
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then(
  //       (result) => {
  //         console.log("response login", result);
  //         if (result.json.aggrement_Status === "TRUE") {
  //           console.log("agr true");
  //           window.location.href =
  //             "https://pguat.safexpay.com/agmerchant/login";
  //         }
  //         this.setState({ isLoaded: false });
  //         let parseAuthtoken = JSON.parse(result.payLoad);
  //         if (result.statusCode === "200") {
  //           localStorage.setItem("Authtoken", parseAuthtoken.Authtoken);
  //           window.location.href = "/business";
  //         } else {
  //           if (result.payLoad === "Password entered is not correct.") {
  //             this.setState({ isInvalid: true });
  //           }
  //           if (result.payLoad === "Invalid User Id.") {
  //             this.setState({ userNotValid: true });
  //           }
  //           if (
  //             result.payLoad ===
  //             "EmailId Is Already Registered Multiple Times. Please Try With New EmailId."
  //           ) {
  //             this.setState({ errorMessage: result.payLoad });
  //           }
  //         }
  //       },
  //       (error) => {
  //         console.log("error", error);
  //         this.setState({ isLoaded: false });
  //         //alert('Failed');
  //         //localStorage.setItem('umail', uname);
  //       }
  //     );
  // };

  requestShopifyData = (encData, redirecturl) => {
    fetch(redirecturl, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        encData: encData,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.status == 200) {
            window.location.href = redirecturl;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  requestShopify = (mercId, domUrl, agFlag) => {
    fetch(`${base_url}api/shopify/loginShopify`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: "",
        meId: mercId,
        domainURL: domUrl,
        aggFlag: agFlag,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.status == 200) {
            this.requestShopifyData(result.encData, result.redirectUrl);
          }
        },
        (error) => {
          console.log("error", error);
        }
      );
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { minLength, upperCase, lowerCase, number } = this.state;
    if (!this.handleEmail()) {
      return false;
    }
    // if (!minLength || !upperCase || !lowerCase || !lowerCase || !number) {
    //   this.setState({ passwordError: "Invalid password format" });
    //   return false;
    // } else {
    //   this.setState({ passwordError: "" });
    // }
    if (this.state.captcha === this.state.genCaptcha) {
      this.setState({ isInvalidCaptcha: false });
    } else {
      this.setState({ isInvalidCaptcha: true });
      return false;
    }

    var uname = event.target.txtUsername.value;
    var upass = event.target.txtPassword.value;
    this.setState({
      isLoaded: true,
      isInvalid: false,
      userNotValid: false,
      errorMessage: "",
    });

    var key = "oqUl4D0LqA4plZw4reAX/K3UKJoQdet0k/N6X6K4Y5k=";
    var base64IV = "0123456789abcdef";

    var parsedBase64Key = CryptoJS.enc.Base64.parse(key);
    var IV = CryptoJS.enc.Utf8.parse(base64IV);
    // Encryption process
    if (typeof upass !== "string") {
      upass = upass.toString();
    }

    // this is Base64-encoded encrypted data
    var encryptedData = CryptoJS.AES.encrypt(upass, parsedBase64Key, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: IV,
    });
    // console.log("encryptedData = ", encryptedData.toString());
    const encryptedCipherText = encryptedData.toString();

    // var decryptedData = CryptoJS.AES.decrypt(
    //   encryptedCipherText,
    //   parsedBase64Key,
    //   {
    //     mode: CryptoJS.mode.CBC,
    //     padding: CryptoJS.pad.Pkcs7,
    //     iv: IV,
    //   }
    // );
    // console.log( "DecryptedData = " + decryptedData );
    // this is the decrypted data as a string
    // var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    // console.log("DecryptedText = " + decryptedText);

    let location = this.props.location;
    let shopifyParams = new URLSearchParams(location.search).get("app");
    let domainUrl = new URLSearchParams(location.search).get("domainURL");

    // let history = this.props.history;
    // history.push("/success");

    fetch(`${base_url}api/merchantLogin`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: uname,
        password: encryptedCipherText,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log("result", result);
          this.setState({ isLoaded: false });

          if (result.json) {
            if (result?.json?.aggrement_Status === "TRUE") {
              console.log("agr true");

              // window.location.href =
              //   "https://pguat.safexpay.com/agmerchant/login";

              if (result.statusCode == "200" && shopifyParams == "shopify") {
                sessionStorage.setItem("shopifyVar", shopifyParams);
                sessionStorage.setItem("me-Id", result.meId);
                sessionStorage.setItem("domain-Url", domainUrl);
                this.requestShopify(result.meId, domainUrl, "N");
              } else {
                window.location.href = `${merchant_url}`;
              }
            }
          }
          if (result.statusCode == "200") {
            console.log("merchant", JSON.parse(result.payLoad));
            const payloadDetails = JSON.parse(result.payLoad);
            const details = result.json;
            // localStorage.setItem("umail", uname);
            // localStorage.setItem("ucompany", details.company_name);
            // localStorage.setItem("ubaddress", details.company_address);
            localStorage.setItem("Authtoken", payloadDetails.Authtoken);
            console.log("details", details);

            let businessDoc;
            let personalDoc;
            if (details.business_document !== "FALSE") {
              businessDoc = JSON.parse(details.business_document);
            }
            if (details.personal_document !== "FALSE") {
              personalDoc = JSON.parse(details.personal_document);
            }

            console.log("details.business_document", businessDoc);
            console.log("details.personal_document", personalDoc);

            if (details.aggrement_Status === "TRUE") {
              // if (result.statusCode == "200" && shopifyParams == "shopify") {
              //   this.requestShopify(payloadDetails.meId, domainUrl);
              // }
              // window.location.href = `${merchant_url}`;
              // window.location.href =
              // "https://pguat.safexpay.com/agmerchant/login";
              
            } else if (payloadDetails.merchant_Details === "False") {
              window.location.href = "/business";
            } else if (payloadDetails.bank_Details === "False") {
              window.location.href = "/bank";
            } else if (
              details.business_document === "FALSE" &&
              details.personal_document === "FALSE"
            ) {
              if (payloadDetails.BusinessType === "Individual") {
                window.location.href = "/personalind";
              } else if (payloadDetails.BusinessType === "Proprietorship") {
                window.location.href = "/personalprop";
              } else if (payloadDetails.BusinessType === "Partnership/LLP") {
                window.location.href = "/personalpart";
              } else if (
                payloadDetails.BusinessType === "PrivateLtd./PublicLtd."
              ) {
                window.location.href = "/personalpub";
              } else if (payloadDetails.BusinessType === "Trust/Society") {
                window.location.href = "/personalsoc";
              }
            } else if (businessDoc) {
              if (payloadDetails.BusinessType === "Proprietorship") {
                for (let key in businessDoc) {
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/businessprop";
              } else if (payloadDetails.BusinessType === "Partnership/LLP") {
                for (let key in businessDoc) {
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/businesspart";
              } else if (
                payloadDetails.BusinessType === "PrivateLtd./PublicLtd."
              ) {
                for (let key in businessDoc) {
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/businesspub";
              } else if (payloadDetails.BusinessType === "Trust/Society") {
                for (let key in businessDoc) {
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/businesssoc";
              }
            } else if (personalDoc) {
              if (payloadDetails.BusinessType === "Individual") {
                for (let key in personalDoc) {
                  if (!key.includes("Pan Card")) {
                    localStorage.setItem("address", key);
                  }
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/personalind";
              } else if (payloadDetails.BusinessType === "Proprietorship") {
                for (let key in personalDoc) {
                  if (!key.includes("Pan Card")) {
                    localStorage.setItem("address", key);
                  }
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/personalprop";
              } else if (payloadDetails.BusinessType === "Partnership/LLP") {
                for (let key in personalDoc) {
                  if (!key.includes("Pan Card")) {
                    if (key.includes("1")) {
                      localStorage.setItem("address1", key);
                    } else {
                      localStorage.setItem("address2", key);
                    }
                  }
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/personalpart";
              } else if (
                payloadDetails.BusinessType === "PrivateLtd./PublicLtd."
              ) {
                for (let key in personalDoc) {
                  console.log("key", key);
                  if (!key.includes("Pan Card")) {
                    if (key.includes("1")) {
                      localStorage.setItem("address1", key);
                    } else {
                      localStorage.setItem("address2", key);
                    }
                  }
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/personalpub";
              } else if (payloadDetails.BusinessType === "Trust/Society") {
                for (let key in personalDoc) {
                  if (!key.includes("Pan Card")) {
                    if (key.includes("1")) {
                      localStorage.setItem("address1", key);
                    } else {
                      localStorage.setItem("address2", key);
                    }
                  }
                  localStorage.setItem(key, "Y");
                }
                window.location.href = "/personalsoc";
              }
            }
            // window.location.href = "/business";
          } else {
            if (result.payLoad === "Password entered is not correct.") {
              this.setState({ isInvalid: true });
            }
            if (result.payLoad === "Invalid User Id.") {
              this.setState({ userNotValid: true });
            }
            if (
              result.payLoad ===
              "EmailId Is Already Registered Multiple Times. Please Try With New EmailId."
            ) {
              this.setState({ errorMessage: result.payLoad });
            }
          }
        },
        (error) => {
          console.log("error", error);
          this.setState({ isLoaded: false });
          //alert('Failed');
          //localStorage.setItem('umail', uname);
        }
      );
  };

  handleEmail = () => {
    if (
      emailValidation(this.state.email.trim()) &&
      this.state.email &&
      this.state.email.length < 65
    ) {
      let sp = this.state.email.split("@")[1].split(".");
      if (sp.length > 3) {
        document.getElementById("txtUsername").classList.add("is-invalid");
        this.setState({ isValidEmail: false });
        return false;
      } else {
        document.getElementById("txtUsername").classList.remove("is-invalid");
        this.setState({ isValidEmail: true });
        return true;
      }
    } else {
      document.getElementById("txtUsername").classList.add("is-invalid");
      this.setState({ isValidEmail: false });
      return false;
    }
  };
  handlePasswordChange = (event) => {
    // console.log("length", this.state.minLength);
    const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    let password = event.target.value;

    //password length
    if (password.length > 7) {
      this.setState({ minLength: true });
    } else {
      this.setState({ minLength: false });
    }

    //password contains numeric value
    if (/^(?=.*\d).+$/.test(password)) {
      this.setState({ number: true });
    } else {
      this.setState({ number: false });
    }

    // password contains lowercase value
    if (/^(?=.*[a-z]).+$/.test(password)) {
      this.setState({ lowerCase: true });
    } else {
      this.setState({ lowerCase: false });
    }

    // password contains uppercase value
    if (/^(?=.*[A-Z]).+$/.test(password)) {
      this.setState({ upperCase: true });
    } else {
      this.setState({ upperCase: false });
    }

    // password contains special char value
    if (/[$-/:-?{-~!"^_`\[\]@#]/.test(password)) {
      this.setState({ specialChar: true });
    } else {
      this.setState({ specialChar: false });
    }
  };

  render() {
    return (
      <>
        <section className="dv-Registration-content">
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <div className="accordion acc-FullyCustomised">
                  <h1 className="section-heading">Safexpay Launcher</h1>

                  <Accordion defaultActiveKey="0">
                    <div className="acc-launcher">
                      <Accordion.Toggle
                        as={Button}
                        variant="link"
                        htmlFor="FlexiQR"
                        eventKey="0"
                        className="heading opened"
                        onClick={() =>
                          this.setState({
                            imageURL: "assets/img/icons/one.png",
                          })
                        }
                      >
                        <strong>FlexiQR, </strong> &nbsp;the most flexible QR
                        solution!
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <div className="description">
                          No need for your customers to install any app, just
                          scan using the phone camera and pay with 100+ payment
                          modes. Create a QR on the fly with our APIs or
                          generate in bulk to display in physical stores.
                          <button
                            className="btn btn-white-rounded"
                            onClick={this.showcontactuspage}
                          >
                            TALK TO US &#10230;
                          </button>
                        </div>
                      </Accordion.Collapse>
                    </div>

                    <div className="acc-launcher" onClick={this.email_Image}>
                      <Accordion.Toggle
                        as={Button}
                        variant="link"
                        htmlFor="UPI Intent Flow"
                        eventKey="1"
                        className="heading"
                      >
                        <strong>UPI Intent Flow, </strong> &nbsp; UPI payment
                        made easy!
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="1">
                        <div className="description">
                          Accept payments from mobile users via UPI payment apps
                          on without any hassles of handling SMS notifications
                          or remembering UPI ID. Just use the preferred app eg.
                          PhonePe, BHIM &amp; accept payments.
                          <button
                            className="btn btn-white-rounded"
                            onClick={this.showcontactuspage}
                          >
                            TALK TO US &#10230;
                          </button>
                        </div>
                      </Accordion.Collapse>
                    </div>
                    <div className="acc-launcher">
                      <Accordion.Toggle
                        as={Button}
                        variant="link"
                        htmlFor="UPI Autopay"
                        eventKey="2"
                        className="heading"
                        onClick={this.checkout_Image}
                      >
                        <strong>UPI Autopay, </strong> &nbsp; Automate your
                        collection.
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="2">
                        <div className="description">
                          Customers can now subscribe for recurring payments
                          using just their UPI App. Sign up today to give your
                          customers a genx experience.
                          <button
                            className="btn btn-white-rounded"
                            onClick={this.showcontactuspage}
                          >
                            TALK TO US &#10230;
                          </button>
                        </div>
                      </Accordion.Collapse>
                    </div>

                    <div className="acc-launcher">
                      <Accordion.Toggle
                        as={Button}
                        variant="link"
                        htmlFor="Digital Onboarding"
                        eventKey="3"
                        className="heading"
                        onClick={this.checkout_Image}
                      >
                        <strong>Digital Onboarding,</strong> &nbsp; Paperless
                        &amp; Secure registration
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="3">
                        <div className="description">
                          Get registered and onboard in minutes with the new
                          state of the art safe &amp; secure Digital Onboarding
                          process. Simply verify your documents and go live.
                          <button
                            className="btn btn-white-rounded"
                            onClick={this.showcontactuspage}
                          >
                            TALK TO US &#10230;
                          </button>
                        </div>
                      </Accordion.Collapse>
                    </div>
                  </Accordion>
                </div>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <form
                  onSubmit={this.handleSubmit}
                  className="dv-login-form dv-form"
                  //action="https://pguat.safexpay.com/agmerchant/login"
                  method="post"
                >
                  <h1 className="section-heading border-heading">Login</h1>

                  {/* <p className="text-center color-lightblue mb-3">Check email for Username &amp; OTP.</p> */}
                  <div className="form-group mx-md-5">
                    <label htmlFor="txtUsername">Email</label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      name="txtUsername"
                      id="txtUsername"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      placeholder="Enter Email"
                      onBlur={this.handleEmail}
                    />
                    {!this.state.isValidEmail && (
                      <small className="err">Please Enter a valid email</small>
                    )}
                  </div>
                  <div className="form-group mx-md-5">
                    {/* error-div */}
                    <label htmlFor="txtOtp">Password</label>
                    <input
                      type="password"
                      required
                      className="form-control"
                      name="txtPassword"
                      id="txtPassword"
                      placeholder="Enter Password"
                      onChange={this.handlePasswordChange}
                    />
                    {/* <div className="err">*Invalid Password</div> */}
                    {this.state.isInvalid && (
                      <small className="err">
                        *Your Username or Password is incorrect.
                      </small>
                    )}
                    {this.state.userNotValid && (
                      <small className="err">*User does not exist.</small>
                    )}
                    <small className="err">{this.state.errorMessage}</small>
                    {/* <small className="err">{this.state.passwordError}</small> */}
                  </div>

                  {/* <span id="password_strength"></span>

                  <div className="progress-bar_wrap">
                    <div className="progress-bar_item progress-bar_item-1">
                      <p className="text-prog">Weak</p>
                    </div>
                    <div className="progress-bar_item progress-bar_item-2">
                      <p className="text-prog">Medium</p>
                    </div>
                    <div className="progress-bar_item progress-bar_item-3">
                      <p className="text-prog">Strong</p>
                    </div>
                  </div>
                  <div className="form-group mt-4 mx-5">
                    <ul className="lipass">
                      <li
                        style={{
                          textDecoration:
                            this.state.minLength && "line-through",
                        }}
                      >
                        Minimum 8 characters
                      </li>
                      <li
                        style={{
                          textDecoration:
                            this.state.upperCase && "line-through",
                        }}
                      >
                        1 Upper Case
                      </li>
                      <li
                        style={{
                          textDecoration:
                            this.state.lowerCase && "line-through",
                        }}
                      >
                        1 Lower Case
                      </li>
                      <li
                        style={{
                          textDecoration: this.state.number && "line-through",
                        }}
                      >
                        1 Numeric Letter
                      </li>
                      <li
                        style={{
                          textDecoration:
                            this.state.specialChar && "line-through",
                        }}
                      >
                        1 Symbol
                      </li>
                    </ul>
                    <div className="clearfix"></div>
                  </div> */}
                  {/* <div className="dv-capcha text-center">
                                        CAPCHA
                                    </div>
                                    <p className="text-center">
                                        <a href="/" className="btn btn-resend-otp btn-link">Resend OTP</a>
                                    </p> */}

                  <div
                    className="dv-captcha__center"
                    style={{ marginTop: "3rem" }}
                  >
                    <div className="gen-captcha">
                      {/* <LoadCanvasTemplate reloadText=" " /> */}
                      <ReCaptcha
                        captcha={this.state.genCaptcha}
                        reload={this.generateNewCaptcha}
                      />
                    </div>
                    <div
                      className="form-group mx-md-5"
                      style={{ width: "79%" }}
                    >
                      <input
                        placeholder="Enter Captcha Value"
                        className="form-control"
                        id="user_captcha_input"
                        name="user_captcha_input"
                        type="text"
                        value={this.state.captcha}
                        onChange={(e) =>
                          this.setState({ captcha: e.target.value })
                        }
                        autoComplete="off"
                      />
                    </div>
                    {this.state.isInvalidCaptcha && (
                      <small className="err">*Invalid captcha</small>
                    )}
                  </div>
                  <div className="btn-holder text-center">
                    <button
                      type="submit"
                      className={
                        this.state.isLoaded
                          ? `btn btn-next btn-gradient disable-btn`
                          : `btn btn-next btn-gradient`
                      }
                      disabled={this.state.isLoaded}
                    >
                      Next
                      {this.state.isLoaded ? (
                        <Spinner
                          size="sm"
                          color="light"
                          className="btn-loader"
                        />
                      ) : null}
                    </button>
                  </div>
                  <p className="text-center">
                    <a
                      href="/forgotpassword"
                      className="btn btn-forgtpass btn-link"
                    >
                      Forgot password
                    </a>
                  </p>
                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?
                      <a href="/support" className="lnk-contact text-underline">
                        Support
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default withRouter(Signin);
